/**
 * @param {File|Blob} file
 * @param {string} [fallbackName]
 */
export function mapFileToFileInfo(file, fallbackName = "file") {
  const name =
    file instanceof File && file.name ? file.name : fallbackName;
  const lastDot = name.lastIndexOf(".");
  const extension =
    lastDot >= 0 ? name.slice(lastDot + 1).toLowerCase() : "";
  const content_type =
    file.type ||
    (extension === "pdf"
      ? "application/pdf"
      : extension === "png"
        ? "image/png"
        : extension === "gif"
          ? "image/gif"
          : extension === "jpg" || extension === "jpeg"
            ? "image/jpeg"
            : extension === "mp4"
              ? "video/mp4"
              : extension === "mov"
                ? "video/quicktime"
                : "application/octet-stream");
  return {
    content_type,
    extension,
    filename: name,
  };
}
